export const USER_ROLES = {
  ADMIN: "admin",
  ITDOG: "itdog",
  LABELER: "labeler",
  DOCTOR: "doctor",
  RA: "ra",
  INSTITUTION_OWNER: "institution_owner",
  PARENTS: "parents",
};

export const ROLE_MAPPING = {
  doctor: USER_ROLES.DOCTOR,
  ra: USER_ROLES.RA,
  labeler: USER_ROLES.LABELER,
  institutionowner: USER_ROLES.INSTITUTION_OWNER,
  admin: USER_ROLES.ADMIN,
  parents: USER_ROLES.PARENTS,
};